import React, { useEffect, useState } from 'react';
import { customStyle } from '../../Components/Style';
import Table from '../../Components/Table';
import moment from 'moment';
import Select from 'react-select';
import { Calendar } from 'antd';
import "react-datepicker/dist/react-datepicker.css";
import "../../Assets/Css/Holiday.scss";
import { useLocation, useNavigate } from 'react-router-dom';
import Calendericon from "../../Assets/Images/Holiday/calendar"
import Listicon from "../../Assets/Images/Holiday/list"
import { getHolidays } from '../../Services/Holiday/action';
import { connect } from 'react-redux';
import { deleteRecord } from '../../Services/Delete/action';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../Lib/RoleWiseFeatureWrapper';
import ModulesList from '../../Assets/ModulesLiist';
import FeaturesList from '../../Assets/FeaturesList';
import { getSundaysInMonth, getAlternateSaturdaysInMonth } from '../../Lib/utils';
import Skeleton from 'react-loading-skeleton';
import EventsListsList from '../../Assets/Images/Attendance/EventsListsList';
import EventsListsCalendar from '../../Assets/Images/Attendance/EventsListsCalendar';

const Holiday = (props) => {
     // Initialize with current month and year
     const currentMonth = moment().month() + 1;
     const currentYear = moment().year();

     const [selectedMonth, setSelectedMonth] = useState({
          value: currentMonth,
          label: moment.months()[currentMonth - 1]
     });
     const [selectedYear, setSelectedYear] = useState({
          value: currentYear,
          label: currentYear
     });
     const [activeButton, setActiveButton] = useState("");
     const [inData, setInData] = useState([]);
     const navigate = useNavigate()
     const location = useLocation();
     const [selectedOccasion, setSelectedOccasion] = useState()

     const canView = checkFeatureAccess({
          modules: props?.modules,
          features: props?.features,
          user: props?.user,
          ModuleName: ModulesList.Holiday,
          Featur_Name: FeaturesList.View,
     });

     const canDelete = checkFeatureAccess({
          modules: props?.modules,
          features: props?.features,
          user: props?.user,
          ModuleName: ModulesList.Holiday,
          Featur_Name: FeaturesList.Delete,
     });
     const canEdit = checkFeatureAccess({
          modules: props?.modules,
          features: props?.features,
          user: props?.user,
          ModuleName: ModulesList.Holiday,
          Featur_Name: FeaturesList.Update,
     });
     useEffect(() => {
          if (location.pathname == "/holiday/calendar") {
               const path = location.pathname.slice(9);
               setActiveButton(path)
          } else {
               const path = location.pathname.slice(1);
               setActiveButton(path)
          }

          props?.getHolidays();
     }, []);

     const handleClick = (buttonId, route) => {
          setActiveButton(buttonId);
          navigate(route);
     };

     const monthOptions = moment.months().map((month, index) => ({
          value: index + 1,
          label: month,
     }));

     const yearOptions = Array.from({ length: 11 }, (_, i) => ({
          value: currentYear - 5 + i,
          label: currentYear - 5 + i,
     }));

     const occasionOptions = [
          { value: 'Festivals', label: 'Festivals' },
          { value: 'Week offs', label: 'Week offs' },
          { value: 'Weekends', label: 'Weekends' },
     ]

     const onPanelChange = (value, mode) => {
          const month = value.month() + 1;
          const year = value.year();
          setSelectedMonth({ value: month, label: moment.months()[month - 1] });
          setSelectedYear({ value: year, label: year });
     };
     const dateCellRender = (value) => {
          const date = value.format('DD-MM-YYYY');
          const holiday = inData?.find(holiday => holiday?.Date?.value == date);

          if (holiday) {
               return (
                    <div className="holiday-marker" onClick={() => navigate('/holiday/view', { state: { data: holiday, from: location.pathname } })}>
                         <span className="holiday-occasion">{holiday.Occasion?.value}</span>
                    </div>
               );
          }

          return null;
     };

     const header = [
          { field: 'Date' },
          { field: 'Occasion' },
          { field: 'Day' },
          { field: 'Action' }
     ];

     useEffect(() => {
          const year = selectedYear?.value || currentYear;
          const month = selectedMonth?.value || currentMonth;
          const dbHolidays = (props?.holiday || [])
               .map(item => ({
                    id: item?.id,
                    date: moment(item?.date?.split(" ")[0]).format('YYYY-MM-DD'),
                    occasion: item?.occasion,
                    fromDb: true
               }))
               .filter(item => {
                    const date = moment(item.date, 'YYYY-MM-DD');
                    return date.month() + 1 === month && date.year() === year;
               });

          const sundayHolidays = getSundaysInMonth(year, month);
          const saturdayHolidays = getAlternateSaturdaysInMonth(year, month);

          let allHolidays = [...dbHolidays, ...sundayHolidays, ...saturdayHolidays].reduce((acc, curr) => {
               if (!acc.find(item => item.date === curr.date)) {
                    acc.push(curr);
               }
               return acc;
          }, []).sort((a, b) => new Date(a.date) - new Date(b.date));

          if (selectedOccasion?.value) {
               if (selectedOccasion.value === 'Festivals') {
                    allHolidays = allHolidays.filter(item => !(item.occasion?.toLowerCase().includes('sunday') || item.occasion?.toLowerCase().includes('week off')));
               } else if (selectedOccasion.value === 'Week offs') {
                    allHolidays = allHolidays.filter(item => item.occasion?.toLowerCase() === 'week off');
               } else if (selectedOccasion.value === 'Weekends') {
                    allHolidays = allHolidays.filter(item => item.occasion?.toLowerCase().includes('sunday') || item.occasion?.toLowerCase().includes('week off'));
               }
          }

          setInData(
               allHolidays.map(item => ({
                    Date: {
                         value: moment(item.date).format('DD-MM-YYYY'),
                         type: 'date'
                    },
                    Occasion: {
                         value: item.occasion,
                         type: 'text'
                    },
                    Day: {
                         value: moment(item.date).format('dddd'),
                         type: 'text'
                    },
                    Action: {
                         value: '/holiday/edit',
                         value2: '/holiday/view',
                         value3: item?.id,
                         showIsDelete: canDelete && item?.fromDb,
                         showIsEdit: canEdit && item?.fromDb,
                         type: 'action'
                    },
                    allData: {
                         ...item
                    }
               }))
          );
     }, [props?.holiday, selectedMonth, selectedYear, selectedOccasion]);


     const handleNavigate = () => {
          navigate("/holiday/add")
     }

     const handleClear = () => {
          // Reset to current month and year instead of null
          setSelectedMonth({
               value: currentMonth,
               label: moment.months()[currentMonth - 1]
          })
          setSelectedYear({
               value: currentYear,
               label: currentYear
          })
          setSelectedOccasion(null)
     }

     return (
          <div className='holiday-container'>
               <div className="page-title">
                    {
                         props.loading ? (
                              <Skeleton className='rounded-2' width={200} height={40} />
                         ) : (
                              <h4>Holiday</h4>
                         )
                    }
                    <div className='add-holiday'>
                         {
                              props.loading ? (<Skeleton className='badge rounded-pill' width={100} height={40} />) : (
                                   <RoleWiseFeatureWrapper
                                        modules={props?.modules}
                                        features={props?.features}
                                        user={props?.user}
                                        ModuleName={ModulesList.Holiday}
                                        Featur_Name={FeaturesList.Create}>

                                        <div className='add-holiday-button'>
                                             <button className='custom-btn' onClick={handleNavigate}>Add Holiday</button>
                                        </div>
                                   </RoleWiseFeatureWrapper>
                              )
                         }
                    </div>
               </div>

               {location.pathname === "/holiday" && (
                    <div className='holiday-filters'>
                         <div className='input-main'>
                              {
                                   props.loading ? (
                                        <Skeleton className='rounded-2' width={200} height={40} />
                                   ) : (
                                        <div className="input-group">
                                             <Select
                                                  options={monthOptions}
                                                  styles={{
                                                       ...customStyle,
                                                       menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                       }),
                                                  }}
                                                  value={selectedMonth}
                                                  onChange={(val) => setSelectedMonth(val)}
                                                  theme={(theme) => ({
                                                       ...theme,
                                                       colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                       },
                                                  })}
                                                  placeholder="Month"
                                             />
                                        </div>
                                   )
                              }

                              {
                                   props.loading ? (
                                        <Skeleton className='rounded-2' width={200} height={40} />
                                   ) : (
                                        <div className="input-group">
                                             <Select
                                                  options={yearOptions}
                                                  styles={{
                                                       ...customStyle,
                                                       menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                       }),
                                                  }}
                                                  value={selectedYear}
                                                  onChange={(val) => setSelectedYear(val)}
                                                  theme={(theme) => ({
                                                       ...theme,
                                                       colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                       },
                                                  })}
                                                  placeholder="Year"
                                             />
                                        </div>
                                   )
                              }

                              {
                                   props.loading ? (
                                        <Skeleton className='rounded-2' width={200} height={40} />
                                   ) : (
                                        <div className="input-group">
                                             <Select
                                                  options={occasionOptions}
                                                  styles={{
                                                       ...customStyle,
                                                       menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                       }),
                                                  }}
                                                  value={selectedOccasion}
                                                  onChange={(val) => setSelectedOccasion(val)}
                                                  theme={(theme) => ({
                                                       ...theme,
                                                       colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                       },
                                                  })}
                                                  placeholder="Select Occasion"
                                             />
                                        </div>
                                   )
                              }

                              <div className='add-holiday input-group'>
                                   {
                                        props.loading ? (
                                             <Skeleton className='badge rounded-pill' width={50} height={40} />
                                        ) : (
                                             <div className='add-holiday-button'>
                                                  <button className='custom-btn' onClick={handleClear}>Reset</button>
                                             </div>
                                        )
                                   }
                              </div>
                         </div>
                    </div>
               )}

               <div className='add-holiday'>

                    {
                         props.loading ? (
                              <Skeleton className="rounded-2" width={40} height={40} />
                         ) : (
                              <div className="navigation_btn">
                                   <button
                                        className={`btn1 ${activeButton === "holiday" ? "active" : ""}`}
                                        onClick={() => handleClick("holiday", "/holiday")}
                                   >
                                        <EventsListsList
                                             color={activeButton === "holiday" ? "white" : "black"}
                                             bgColor={activeButton === "holiday" ? "black" : "white"}
                                        />
                                   </button>
                                   <button
                                        className={`btn1 ${activeButton === "calendar" ? "active" : ""}`}
                                        onClick={() => handleClick("calendar", "/holiday/calendar")}
                                   >
                                        <EventsListsCalendar
                                             color={activeButton === "calendar" ? "white" : "black"}
                                             bgColor={activeButton === "calendar" ? "black" : "white"}
                                        />
                                   </button>
                              </div>
                         )
                    }

               </div>

               <div className='holiday-view'>
                    {location.pathname === "/holiday" && (
                         <div className='holiday-table'>
                              {
                                   props.loading ? (
                                        <Skeleton count={5} width="100%" height={40} />
                                   ) : (
                                        <Table
                                             deleteRecord={props?.deleteRecord}
                                             loading={props?.loading}
                                             data={inData}
                                             header={header}
                                             showIsView={canView}
                                             footer={true}
                                             count={inData?.length}
                                             records={inData?.length}
                                        />
                                   )
                              }
                         </div>
                    )}
                    {location.pathname === "/holiday/calendar" && (
                         <div className='holiday-calendar'>
                              {
                                   props.loading ? (
                                        <Skeleton className='rounded-2' width="100%" height="100vh" />
                                   ) : (
                                        <Calendar
                                             mode="month"
                                             dateCellRender={dateCellRender}
                                             onPanelChange={onPanelChange}
                                        />
                                   )
                              }
                         </div>
                    )}
               </div>
          </div>
     );
}

const mapStateToProps = (state) => {
     return {
          holiday: state.holidayReducer.holiday,
          loading: state.holidayReducer.loading,
          modules: state.authenticationReducer.modules,
          features: state.authenticationReducer.features,
          user: state.authenticationReducer.user
     }
}

const mapDispatchToProps = (dispatch) => {
     return {
          getHolidays: () => {
               dispatch(getHolidays())
          },
          deleteRecord: async (id, inputValue) => {
               await dispatch(deleteRecord(id, inputValue))
               await dispatch(getHolidays());
          },
     }
}

export default connect(mapStateToProps, mapDispatchToProps)(Holiday);